import { z } from "zod/v4";

import { ExperienceVariationPricesDtoSchema } from "./variation-prices";

export const ExperienceProductVariantDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  variationPrices: ExperienceVariationPricesDtoSchema.array().default([]),
});
export type ExperienceProductVariantDto = z.infer<
  typeof ExperienceProductVariantDtoSchema
>;

export const ExperienceProductDtoSchema = z.object({
  id: z.string(),
  title: z.string().nullish().optional(),
  variants: ExperienceProductVariantDtoSchema.array(),
  handle: z.string().nullish().optional(),
  altHandles: z.record(z.string(), z.string()).nullish().optional(),
  altIds: z.record(z.string(), z.string()).nullish().optional(),
  image: z.string().nullish(),
  requiresSellingPlan: z.boolean().optional(),
  experienceId: z.uuid(),
});
export type ExperienceProductDto = z.infer<typeof ExperienceProductDtoSchema>;

export const CreateExperienceProductDtoSchema =
  ExperienceProductDtoSchema.extend({
    experienceId: z.uuid().optional(),
  });
export type CreateExperienceProductDto = z.infer<
  typeof CreateExperienceProductDtoSchema
>;
